<template>
  <el-dialog :title="$lang('取消订单')" width="400px"
             :visible.sync="dialogVisible"
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             @close="onClose">
    <div class="TheCancelOrder">
      <el-form :model="form" ref="form" class="d-flex flex-column">
        <el-form-item>
          <h3 class="label">{{ $lang('请选择取消订单的原因') }}</h3>
          <el-radio-group v-model="radio" class="d-flex flex-column">
            <el-radio :label="1">{{ $lang('下单等太久，快递员未来取件') }}</el-radio>
            <el-radio :label="2">{{ $lang('计划有变暂时不需要寄件了') }}</el-radio>
            <el-radio :label="3">{{ $lang('赶时间更改为其他寄件方式') }}</el-radio>
            <el-radio :label="4">{{ $lang('订单信息填写有误，需要修改') }}</el-radio>
            <el-radio :label="5" :value="$lang('其它')">{{ $lang('其它') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="radio === 5" prop="textarea" :rules="{required: true, message: '请填写原因', trigger: 'blur'}">
          <el-input type="textarea"
                    v-model="form.textarea"
                    :autosize="{ minRows: 3, maxRows: 6}"
                    :placeholder="$lang('请填写订单取消原因')"
                    :maxlength="40"/>
        </el-form-item>
      </el-form>
      <div class="line">
        <el-button type="primary" @click="handelCancel('form')" :loading="isLoading" class="h40">{{ $lang('确定取消') }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { fetchCancelExchange } from '@/api/module/customer'
import { RESPONSE_SUCCESS } from '@/constants'

export default {
  name: 'TheCancelOrder',
  props: {
    selectId: {
      type: Array,
      default: () => {
        return []
      },
    },
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      radio: 1,
      form: {
        textarea: ''
      },
      isLoading: false,
    }
  },
  computed: {
    reason() {
      let text = ''
      switch (this.radio) {
        case 1:
          text = this.$lang('下单等太久，快递员未来取件')
          break
        case 2:
          text = this.$lang('计划有变暂时不需要寄件了')
          break
        case 3:
          text = this.$lang('赶时间更改为其他寄件方式')
          break
        case 4:
          text = this.$lang('订单信息填写有误，需要修改')
          break
      }
      return text
    }
  },
  methods: {
    async handelCancel(formName) {
      if (this.selectId.length > 0) {
        this.isLoading = true
        const params = {
          orderIds: this.selectId,
          reason: this.radio === 5 ? this.form.textarea : this.reason,
          from: 8
        }
        this.$refs[formName].validate(async valid => {
          if (valid) {
            try {
              const { code, msg } = await fetchCancelExchange(params)
              if (code === RESPONSE_SUCCESS) {
                this.$message.success(this.$lang('取消成功'))
                this.$emit('update:dialogVisible', false)
                this.radio = 1
                this.form.textarea = ''
                this.$emit('cancelSuccess')
              } else {
                this.$message.error(msg)
              }
            } catch (e) {
              this.$message.error(e)
            }
            this.isLoading = false
          } else {
            this.isLoading = false
            return false
          }
        })
      }
    },
    onChange(val) {
      console.log(val)
    },
    onClose() {
      this.$emit('update:dialogVisible', false)
    },
  }
}
</script>

<style lang="scss" scoped>
.TheCancelOrder {
  ::v-deep {
    .el-radio {
      display: flex;
      align-items: flex-start;
      line-height: 30px;

      .el-radio__input {
        line-height: 30px;
      }

      .el-radio__label {
        white-space: pre-wrap;
      }
    }
  }

  .el-form {
    padding: 0 20px;
  }

  .label {
    font-size: 18px;
    font-weight: 400;
    margin: 0;
    color: #000000;
    padding-bottom: 10px;
  }

  .line {
    border-top: 1px solid rgba(0, 0, 0, 0.07);
    padding: 25px 0 15px;
    text-align: center;
    margin-top: 10px;
  }
}
</style>
